import React from 'react'
import classes from './Logo.scss'
import seekpi from '../../assets/final-SEEKPI.png'

const logo = () => (
  <div className={classes.Logo}>
    <img src={seekpi} alt='logo' />
  </div>
)

export default logo
